import React from 'react';
import Icon from './icons';
import { useTheme } from '../hooks/useTheme';

export default function MobileLayout({ page, setPage, children }) {
  const { isDark, toggleTheme } = useTheme();

  const tabs = [
    { id: 'home', label: 'Home', icon: Icon.home },
    { id: 'extract', label: 'Queue', icon: Icon.extract },
    { id: 'catalog', label: 'Products', icon: Icon.catalog },
    { id: 'orders', label: 'Orders', icon: Icon.orders },
    { id: 'settings', label: 'Settings', icon: Icon.settings },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-bg-base)' }}>
      <div style={{ paddingBottom: '80px' }}>{children}</div>
      <nav className="bottom-tab-bar">
        {tabs.slice(0, 2).map(t => (
          <button key={t.id} className={`bottom-tab ${page === t.id ? 'active' : ''}`} onClick={() => setPage(t.id)}>
            {t.icon(18)}<span>{t.label}</span>
          </button>
        ))}
        <div className="tab-fab-wrapper">
          <button className="tab-fab" onClick={() => setPage('extract')} title="Quick Add">{Icon.plus(24)}</button>
        </div>
        {tabs.slice(2).map(t => (
          <button key={t.id} className={`bottom-tab ${page === t.id ? 'active' : ''}`} onClick={() => setPage(t.id)}>
            {t.icon(18)}<span>{t.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}
